<template>
  <v-container fill-height justify-content-start class="app-section-width pa-0">
    <v-layout v-if="pages.page" column>
      <div class="activity-header pb-10">
        <div class="activity-title" :class="{ 'pl-0': $vuetify.breakpoint.xsOnly }">
          <v-icon @click="$router.go(-1)" color="white" class="ms-3 me-3">mdi-arrow-left</v-icon>
          <v-toolbar-title>{{ pageName }}</v-toolbar-title>
        </div>
        <v-img :set="url = coverImageUrl" :lazy-src="url" :src="url" />
      </div>
      <reservation-type-chip :reservationMethodType="reservationMethod.type" />
      <summary-data class="mt-2" />
    </v-layout>
  </v-container>
</template>

<script>
import store from '@/store'
import router from '@/router'
import routeNames from '@/router/routes'
import { mapGetters, mapState } from 'vuex'
import activityMixins from '@/mixins/Activity'
import reservationMixins from '@/mixins/Reservation'

export default {
  beforeRouteEnter (to, from, next) {
    if (
      from.name === routeNames.reservationCommonData.name ||
      from.name === routeNames.reservationCatalog.name ||
      from.name === routeNames.catalogCategorySelection.name
    ) {
      if (store.getters['activityReservations/isUnsaved']) {
        next()
      } else {
        router.go(-1)
      }
    } else {
      router.go(-1)
    }
  },
  props: {
    isComponent: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      pendingConfirmation: false,
    }
  },
  created () {
    if (!this.activityReservations.edited.activityId) {
      this.$router.push({ name: routeNames.reservationCommonData.name })
    }
    this.$store.dispatch('me/getBookings')
    this.$store.dispatch('pages/get', { id: this.$route.params.pageId }).then((page) => {
      const activityId = page.pageSpecific.activityId
      this.$store.dispatch('activities/getActivity', {
        id: activityId,
      })
    })
  },
  computed: {
    ...mapGetters({
      pageName: 'pages/pageName',
      coverImageUrl: 'pages/coverImageUrl',
    }),
    ...mapState([
      'activities',
      'activityReservations',
      'pages',
    ]),
  },
  components: {
    ReservationTypeChip: () => import('@/components/view-components/reservations/ReservationTypeChip.vue'),
    SummaryData: () => import('@/components/view-components/catalog/Summary.vue'),
  },
  mixins: [
    activityMixins,
    reservationMixins,
  ],
}
</script>

<style lang="scss" scoped>
.activity-header {
  max-width: 100%;
  min-height: 90px;
  max-height: 90px;
  overflow: hidden;
  display: flex;
  align-items: center;
  position: relative;
  & .activity-title {
    position: absolute;
    z-index: 1;
    top: 8px;
  }
}
</style>
